<template>
    <div class="home">
        <div class="user_info">
            <img :src="userInfo.avatar" class="avatar" @click="router.push('/workbench/personal/account')" alt />
            <div>
                <p class="nickname">{{ userInfo.nickname }} <img src="@/assets/imgs/icon53.png" alt=""></p>
                <p class="phone">{{ userInfo.mark }}</p>
                <p class="follow">粉丝 <b>{{ userInfo.fansCount }}</b> <i>|</i> 关注 <b>{{ userInfo.followCount }}</b></p>
            </div>
        </div>
        <div class="id_info">
            <div>ID: {{ userInfo.id }} <img src="@/assets/imgs/icon54.png" alt="" @click="copyToClipboard(userInfo.id)"></div>
            <div>区块链地址: {{ userInfo.txId }} <img src="@/assets/imgs/icon54.png" alt="" @click="copyToClipboard(userInfo.txId)"></div>
        </div>
        <div class="row-wrapper">
            <section class="t">
                <div class="row">
                    <span class="row-label"> <strong class="row-hot">{{ formatPrice(account.balance) }}</strong>
                        <span>账户余额</span></span>
                    <!-- <span class="btn primary"  @click="router.push({ path: '/workbench/personal/withdraw' })">提现</span> -->
                    <span style="margin-left: 20rem;" class="btn"
                        @click="router.push({ path: '/workbench/personal/expense' })">收支明细</span>
                </div>
                <div class="line"></div>
                <div class="list">
                    <div class="list-item">
                        <span class="label">总收益</span>
                        <span class="value">{{ formatPrice(account.totalIncome) }}</span>
                    </div>
                    <div class="list-item">
                        <span class="label">现中</span>
                        <span class="value">{{ formatPrice(account.freezePrice) }}</span>
                    </div>
                    <div class="list-item">
                        <span class="label">已提现</span>
                        <span class="value">{{ formatPrice(account.withdrawalAmount) }}</span>
                    </div>
                    <div class="list-item">
                        <span class="label">已消费</span>
                        <span class="value">{{ formatPrice(account.consumptionAmount) }}</span>
                    </div>
                </div>
            </section>
            <section class="ng-item">
                <div class="assetsLib-first">
                    <h2>区块链查询</h2>
                </div>
                <div class="search-body">
                    <van-search v-model="keyword" placeholder="请输入哈希值或区块链地址核验" show-action @search="handleSearch">
                        <template #action>
                            <span class="search-btn" @click="handleSearch">查询</span>
                        </template>
                    </van-search>
                </div>
            </section>
        </div>
        <section class="fn">
            <h2>功能导航</h2>
            <ul class="navigation clearfix">
                <li class="navigation-item" v-for="item in fnList" :key="item.path" @click="onJumpLink(item.path)">
                    <i class="icon" :class="[item.className]" />
                    <span class="label">{{ item.label }}</span>
                </li>
            </ul>
        </section>
        <div class="middle bg">
            <section style="width: 100%;">
                <h2 style="margin-bottom: 10rem;">资产统计</h2>
                <div class="account">
                    <ul class="clearfix">
                        <li>
                            <span class="label">资产空间</span>
                            <span class="value">{{ (accountInfo.assetSpace / 1024 / 1024 / 1024).toFixed(2) }} <span
                                    class="value-unit">GB</span></span>

                        </li>
                        <li>
                            <span class="label">资产数量</span>
                            <span class="value">{{ accountInfo.assetNum }} <span class="value-unit">个</span></span>
                        </li>
                        <li>
                            <span class="label">本周上传</span>
                            <span class="value">{{ accountInfo.weekUploadNum }} <span class="value-unit">个</span></span>

                        </li>
                        <li>
                            <span class="label">模型数量</span>
                            <span class="value">{{ accountInfo.modelNum }} <span class="value-unit">个</span></span>

                        </li>
                        <li>
                            <span class="label">作品数量</span>
                            <span class="value">{{ accountInfo.workNum }} <span class="value-unit">个</span></span>

                        </li>
                        <li>
                            <span class="value">0 <span class="value-unit">个</span></span>
                            <span class="label">版权登记</span>
                        </li>
                        <li>
                            <span class="label">发布数量</span>
                            <span class="value">{{ accountInfo.releaseNum }} <span class="value-unit">个</span></span>

                        </li>
                        <li>
                            <span class="label">购买数量</span>
                            <span class="value">{{ accountInfo.purchaseNum }} <span class="value-unit">个</span></span>

                        </li>
                        <li>
                            <span class="label">下载次数</span>
                            <span class="value">{{ accountInfo.downloadNum }} <span class="value-unit">个</span></span>

                        </li>
                    </ul>
                </div>
            </section>
        </div>
        <div class="middle">
            <section class="bg-item" style="width: 100%;">
                <h2>资产格式</h2>
                <div style="height: 236rem; background-color: #FFF; border-radius: 5rem;" ref="chart_2"></div>
            </section>
            <section class="bg-item" style="width: 100%;">
                <h2>资产上传</h2>
                <div style="height: 236rem; background-color: #FFF; border-radius: 5rem;" ref="chart_1"></div>
            </section>
            <section class="bg-item" style="width: 100%;">
                <h2>资产分类</h2>
                <div style=" height: 236rem; background-color: #FFF; border-radius: 5rem;" ref="chart_4"></div>
            </section>
        </div>
    </div>

</template>

<script setup>
import { onMounted, reactive, ref, computed } from 'vue'
import * as echarts from 'echarts';
import { http } from '@/request/http'
import { useRouter } from 'vue-router';
import { formatPrice } from '@/utils/util';
import { showNotify } from 'vant';
import { useStore } from 'vuex';


const router = useRouter()
const store = useStore()

const userInfo = computed(() => store.state.login.userInfo)
const account = ref({})
const fnList = reactive([
    // { path: '/workbench/assetlibs/upload', label: '资产上传', className: 'icon-1' },
    { path: '/workbench/assets-lib/asset', label: '资产管理', className: 'icon-2' },
    // { path: '/workbench/personal/price', label: '定价发布', className: 'icon-3' },
    { path: '/workbench/personal/release', label: '我的发布', className: 'icon-4' },
    // { path: '/workbench/personal/virtual', label: '虚拟展馆', className: 'icon-5' },
    { path: '/workbench/personal/collection', label: '我的收藏', className: 'icon-6' },
    { path: '/workbench/personal/follow', label: '我的关注', className: 'icon-7' },
    { path: '/workbench/personal/expense', label: '收支明细', className: 'icon-8' },
    { path: '/workbench/personal/receipt', label: '发票管理', className: 'icon-9' },
])

const chart_1 = ref(null)
const chart_2 = ref(null)
const chart_4 = ref(null)

function initChart1() {
    http.get('/app-api/model/asset-day-count/getByUser').then(res => {
        var chart = echarts.init(chart_1.value);

        const xAxisData = res.countDates.map(item => item.slice(5)).slice(0, 10);

        chart.setOption({
            grid: {
                Left: '20rem',
                right: '10rem',
                top: '40rem',
                bottom: '40rem'
            },
            legend: {
                data: ['模型数量', '作品数量'],
                top: '2%',
                right: '50rem',
                textStyle: {
                    fontSize: 12
                },
                icon: 'circle',
                itemWidth: 8,
                itemHeight: 8,
                textStyle: {
                    color: 'rgba(139, 139, 139, 1)'
                }
            },
            xAxis: {
                type: 'category',
                data: xAxisData,
                axisLabel: {
                    interval: 0,
                    rotate: 30
                }
            },
            yAxis: {
                type: 'value',
                name: '数量',
                nameTextStyle: {
                    padding: [0, 0, 0, 10]
                }
            },
            series: [
                {
                    name: '模型数量',
                    data: res.modelNums.slice(0, 10),
                    type: 'line',
                    smooth: true,
                    areaStyle: {
                        opacity: 0.8,
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgba(87, 194, 242, 0.2)'
                            },
                            {
                                offset: 1,
                                color: 'rgba(87, 194, 242, 0)'
                            }
                        ])
                    },
                    symbol: 'circle',
                    symbolSize: 6,
                    label: {
                        show: true,
                        position: 'top',
                        fontSize: 10,
                        formatter: (params) => {
                            return params.value === 0 ? '' : params.value;
                        }
                    },
                    lineStyle: {
                        width: 2
                    },
                    itemStyle: {
                        color: 'rgba(87, 194, 242, 1)'
                    }
                },
                {
                    name: '作品数量',
                    data: res.workNums.slice(0, 10),
                    type: 'line',
                    smooth: true,
                    areaStyle: {
                        opacity: 0.8,
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgba(176, 174, 243, 0.2)'
                            },
                            {
                                offset: 1,
                                color: 'rgba(176, 174, 243, 0)'
                            }
                        ])
                    },
                    symbol: 'diamond',
                    symbolSize: 6,
                    label: {
                        show: true,
                        position: 'top',
                        fontSize: 10,
                        formatter: (params) => {
                            return params.value === 0 ? '' : params.value;
                        }
                    },
                    lineStyle: {
                        width: 2,
                        type: 'dashed'
                    },
                    itemStyle: {
                        color: 'rgba(176, 174, 243, 1)'
                    }
                }
            ]
        });

        window.addEventListener('resize', () => {
            chart.resize();
        });
    });
}

function initChart2() {
    http.get('/app-api/model/asset-count/format').then(res => {
        var chart = echarts.init(chart_2.value)
        chart.setOption({
            color: ['#477BFF', '#47D1CB', '#6F47FF', '#FFCB47', '#FF477B'],
            tooltip: {
                trigger: 'item'
            },
            legend: {
                bottom: 0,
                left: 'center',
                itemWidth: 10,
                itemHeight: 10,
                borderRadius: 5,
                itemGap: 20,
                textStyle: {
                    color: 'rgba(139, 139, 139, 1)'
                }
            },
            series: [
                {
                    type: 'pie',
                    radius: ['0', '70%'],
                    left: 'center',
                    top: 'top',
                    width: '180rem',
                    height: '180rem',
                    data: res.map(item => {
                        return {
                            name: item.modelFormat,
                            value: item.modelNum
                        }
                    }),
                    label: {
                        show: false
                    }
                }
            ]
        })
    })
}

function initChart4() {
    http.get('/app-api/model/asset-count/cate').then(res => {
        res = res ? res.slice(0, 8) : []
        var chart = echarts.init(chart_4.value)
        chart.setOption({
            grid: {
                left: '20rem',
                right: '10rem',
                top: '30rem',
                bottom: '40rem'
            },
            xAxis: {
                data: res.map(item => item.platformCateName.slice(0, 3))
            },
            yAxis: {
                type: 'value'
            },
            legend: {
                data: ['模型', '作品'],
                right: '50rem',
                top: '2%',
                // icon: 'circle',
                itemWidth: 8,
                itemHeight: 8,
                textStyle: {
                    color: 'rgba(139, 139, 139, 1)'
                }
            },
            series: [
                {
                    name: '模型',
                    data: res.map(item => item.modelNum),
                    type: 'bar',
                    barMaxWidth: '12rem',
                    itemStyle: {
                        color: '#477BFF',
                        // borderRadius: [5, 5, 0, 0]
                    },
                    label: {
                        show: true,
                        position: 'insideTop',
                        formatter: function (params) {
                            return params.value === 0 ? '' : params.value;
                        }
                    }
                },
                {
                    name: '作品',
                    data: res.map(item => item.workNum),
                    type: 'bar',
                    barMaxWidth: '12rem',
                    itemStyle: {
                        color: '#47D1CB',
                        // borderRadius: [5, 5, 0, 0]
                    },
                    label: {
                        show: true,
                        position: 'insideTop',
                        formatter: function (params) {
                            return params.value === 0 ? '' : params.value;
                        }
                    }
                }
            ]
        })
    })
}

const queryData = () => {
    http.get('/app-api/pay/wallet/get').then(res => {
        account.value = res
    })
}
const onJumpLink = path => {
    router.push(path)
}
const keyword = ref('')
const handleSearch = () => {
    if (keyword.value == '') return showNotify({ type: 'warning', message: '请输入查询信息！' })
    router.push({ path: "personal/verification", query: { keyword: keyword.value } })
}
const accountInfo = reactive({
    "assetSpace": 0,
    "assetNum": 0,
    "modelNum": 0,
    "workNum": 0,
    "purchaseNum": 0,
    "releaseNum": 0,
    "downloadNum": 0,
    "weekUploadNum": 0
})
onMounted(() => {
    queryData()
    initChart1()
    initChart2()
    initChart4()
    http.get('/app-api/model/asset-count/getByUser').then(res => {
        Object.assign(accountInfo, res)
    })
})
const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
    showNotify({ type: 'success', message: '复制成功！' })
}
</script>

<style lang="scss" scoped>
@use "./var.scss" as var;

.home {
    width: 100%;
    height: 100%;
    padding: 10rem 20rem;
    background-image: linear-gradient(180deg, rgba(35, 137, 245, 0.1) 0%, #F7F7F9 300rem);

    .user_info {
        display: flex;
        align-items: center;
        .avatar {
            width: 60rem;
            height: 60rem;
            border-radius: 50rem;
            margin-right: 20rem;
        }

        p {
            font-size: 12rem;
            color: #8D8D8D;
            height: 24rem;
        }

        .nickname {
            font-size: 16rem;
            color: #000;
            font-weight: bold;
            margin-bottom: 10rem;

            img {
                width: 20rem;
                height: 20rem;
            }
        }

        .follow {
            font-size: 14rem;

            i {
                margin: 0 10rem;
            }

            b {
                color: #313131;
                font-weight: normal;
                margin-left: 10rem;
            }
        }
    }

    .id_info {
        display: flex;
        margin: 10rem 0;
        justify-content: space-between;

        div {
            width: 190rem;
            height: 24rem;
            line-height: 24rem;
            background-color: #fff;
            padding: 0 10rem;
            font-size: 12rem;
            color: #8D8D8D;
            position: relative;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            img {
                width: 18rem;
                height: 18rem;
                position: absolute;
                right: 5rem;
                top: 2rem;
            }
        }
    }

    section {
        h2 {
            font-size: 16rem;
            font-weight: 500;
            color: #010101;
            display: flex;
            align-items: center;
        }

        h2::before {
            content: '';
            width: 4rem;
            height: 16rem;
            background-color: var.$blueBg;
            margin-right: 10rem;
        }
    }

    .row-wrapper {
        display: flex;
        gap: 16rem;
        flex-direction: column;

        @media (min-width: 768px) {
            flex-direction: row;
        }
    }

    .ng-item {
        background-color: #fff;
        padding: 20rem 24rem;

        .assetsLib-first {
            padding-bottom: 10rem;
        }
    }

    .navigation {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        overflow-x: scroll;
        padding: 0 10rem;

        &-item {
            float: left;
            margin-right: 20rem;
            padding: 10rem 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 50rem;

            .icon {
                margin-bottom: 10rem;
                width: 50rem;
                height: 50rem;
                border-radius: 25rem;
                background: #FFEAEA;
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;

                &-1 {
                    background-image: url(@/assets/img/personal/icon-1.png);
                }

                &-2 {
                    background-image: url(@/assets/img/personal/icon-2.png);
                }

                &-3 {
                    background-image: url(@/assets/img/personal/icon-3.png);
                }

                &-4 {
                    background-image: url(@/assets/img/personal/icon-4.png);
                }

                &-5 {
                    background-image: url(@/assets/img/personal/icon-5.png);
                }

                &-6 {
                    background-image: url(@/assets/img/personal/icon-6.png);
                }

                &-7 {
                    background-image: url(@/assets/img/personal/icon-7.png);
                }

                &-8 {
                    background-image: url(@/assets/img/personal/icon-8.png);
                }

                &-9 {
                    background-image: url(@/assets/img/personal/icon-9.png);
                }
            }

            .label {
                width: 50rem;
                font-size: 12rem;
                font-weight: 400;
                color: #333;
            }

        }

        @media (min-width: 768px) {
            &-item {
                width: 160rem;
                height: 80rem;
                margin: 0 22rem 10rem 0;
                flex-direction: row;

                .icon {
                    margin-right: 10rem;
                    margin-bottom: 0;
                    width: 30rem;
                    height: 30rem;
                }

                .label {
                    font-size: 16rem;
                }
            }
        }
    }

    .navigation::webkit-scrollbar {
        display: none;
    }

    .account {
        ul {
            display: flex;
            flex-wrap: wrap;

            li {
                width: 110rem;
                height: 54rem;
                margin: 5rem;
                border-radius: 0;
                background: linear-gradient(180deg, rgba(35, 137, 245, 0.15) 0%, rgba(35, 137, 245, 0.05) 100%);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border-radius: 5rem;

                &:last-of-type {
                    margin-right: 0;
                }

                .label {
                    font-size: 12rem;
                    font-weight: 400;
                    color: #888;
                }

                .value {
                    font-size: 18rem;
                    font-weight: 500;
                    color: #000;

                    &-unit {
                        font-size: 12rem;
                    }
                }
            }

            @media (min-width: 768px) {
                display: block;

                li {
                    width: 160rem;
                    height: 78rem;
                    margin: 0 16rem 10rem 0;
                    border-radius: 10rem;
                    border: none;

                    .value {
                        font-size: 20rem;

                        &-unit {
                            font-size: 14rem;
                        }
                    }
                }
            }
        }
    }

    .middle {
        width: 100%;
        margin-bottom: 20rem;

        &.bg {
            background-color: #fff;
            border-radius: 8rem;
            padding: 15rem;
            margin-bottom: 15rem;
        }

        .bg-item {
            width: 100% !important;
            padding: 15rem;
            background-color: #fff;
            border-radius: 6rem;
            margin-bottom: 15rem;

            h2 {
                margin-bottom: 8rem;
            }
        }

        @media (min-width: 768px) {
            flex-direction: row;

            .bg-item {
                width: 19% !important;

                &.chart-upload {
                    width: 31% !important;
                }

                &.chart-cate {
                    width: 48% !important;
                }
            }
        }
    }

    .ng-item,
    .t {
        background-color: #fff;
        border-radius: 10rem;
        width: 100%;
    }

    .t {
        flex: 1;
        padding: 20rem 16rem;

        .list {
            display: flex;
            justify-content: space-between;
            gap: 10rem;

            .list-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 80rem;

                .label {
                    font-size: 12rem;
                    font-weight: 400;
                    color: #8B8B8B;
                }

                .value {
                    margin-top: 2rem;
                    font-size: 16rem;
                    font-weight: 500;
                    color: #000000;
                }
            }
        }

        .line {
            margin: 10rem;
            width: 100%;
            height: 1px;
            background-color: #F8F8FA;
        }

        .row {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            align-items: center;
            height: auto;
            min-height: 50%;

            .line {
                width: 100%;
                height: 1px;
                margin: 10rem 0;
                background-color: #F8F8FA;
            }

            &-hot {
                font-size: 20rem;
                font-weight: 500;
                color: #FB0200;
            }

            &-label {
                font-size: 16rem;
                font-weight: 500;
                color: #000000;
                display: flex;
                flex-direction: column;
                align-items: center;
                flex-wrap: wrap;
                gap: 10rem;
            }

            .btn {
                border: 1rem solid #8B8B8B;
                width: 68rem;
                height: 26rem;
                font-size: 14rem;
                text-align: center;
            }

        }

        @media (min-width: 768px) {
            padding: 30rem 25rem;

            .list {
                display: grid;
                grid-template: 80rem / repeat(4, 1fr);
                gap: 0;
            }

            .row {
                display: flex;
                flex-wrap: nowrap;
                height: 50%;

                .line {
                    width: 1rem;
                    height: 14rem;
                    margin: 0 10rem;
                }

                &-hot {
                    font-size: 24rem;
                }

                &-label {
                    font-size: 20rem;
                    flex-wrap: nowrap;
                }
            }

            .line {
                display: block;
                width: 100%;
                height: 2px;
                background: #F8F8FA;
            }
        }
    }
}

.fn {
    margin: 15rem 0;
    border-radius: 10rem;
    padding: 18rem 15rem;
    background-color: #fff;

    h2 {
        margin-bottom: 10rem;
    }
}

.search-body {
    background-color: #fff;

    .search-btn {
        background-color: #000;
        color: #fff;
        padding: 0 15rem;
        border-radius: 0 2rem 2rem 0;
        height: 40rem;
        display: flex;
        align-items: center;
    }
}
</style>
